import { unstable_cache } from "next/cache";
import { ApiFilterResponse } from "@interfaces/filter.types";
import { CACHE_REVALIDATION, CACHE_TAGS } from "@constants/cacheConfig";

const baseURL = process.env.NEXT_PUBLIC_ACKO_DRIVE_CATALOG_SERVICE;

export const fetchFiltersFromAPI = async (
  collectionSlug?: string
): Promise<ApiFilterResponse | null> => {
  try {
    const queryParams = new URLSearchParams();

    if (collectionSlug) {
      const decodedSlug = decodeURIComponent(collectionSlug);
      queryParams.append("slug", decodedSlug);
    }

    const apiUrl = `${baseURL}/v1/filters/?${queryParams.toString()}`;

    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`API returned status ${response.status}`);
    }

    const data = await response.json();

    return data;
  } catch (error: any) {
    console.error("[Filter Service] ❌ Error fetching filter options:", error?.message);
    return null;
  }
};

const getCachedFiltersForHeader = unstable_cache(
  async () => {
    return fetchFiltersFromAPI();
  },
  ["filter-data-header"],
  {
    revalidate: CACHE_REVALIDATION.FILTER_DATA,
    tags: [CACHE_TAGS.FILTER_DATA],
  }
);

export const filterService = {
  getFilters: async (collectionSlug?: string) => {
    
    if (collectionSlug) {
      return fetchFiltersFromAPI(collectionSlug);
    }
    
    return getCachedFiltersForHeader();
  },
};
